import React from 'react';
import { allEntrancesId, allHallsId } from 'config/constants';
import verticesOnFloor from 'config/verticesOnFloor';
import txtEnt1 from 'assets/images/txt_entrance_01.svg';
import txtEnt2 from 'assets/images/txt_entrance_02.svg';
import txtEnt3 from 'assets/images/txt_entrance_03.svg';
import txtEnt4 from 'assets/images/txt_entrance_04.svg';
import txtEnt5 from 'assets/images/txt_entrance_05.svg';
import txtEnt6 from 'assets/images/txt_entrance_06.svg';
import txtEnt7 from 'assets/images/txt_entrance_07.svg';
import txtEnt8 from 'assets/images/txt_entrance_08.svg';
import txtEnt9 from 'assets/images/txt_entrance_09.svg';
import txtEnt10 from 'assets/images/txt_entrance_10.svg';
import txtEnt11 from 'assets/images/txt_entrance_11.svg';
import txtHall1 from 'assets/images/txt_h1.svg';
import txtHall2 from 'assets/images/txt_h2.svg';
import txtHall3 from 'assets/images/txt_h3.svg';
import txtHall4 from 'assets/images/txt_h4.svg';
import txtHall5 from 'assets/images/txt_h5.svg';
import aeonLogo from 'assets/images/logo_aeon.svg';
import aeonHall from 'assets/images/txt_aeon_hall.svg';




import DynamicIcon from 'components/DynamicIcon';
import { number } from 'prop-types';


StaticData.propTypes = {
  floorLevel: number,
  rotate: number
};

function StaticData({ floorLevel, rotate}) {
  
  const entranceHrefArr = [
    txtEnt1,
    txtEnt2,
    txtEnt3,
    txtEnt4,
    txtEnt5,
    txtEnt6,
    txtEnt7,
    txtEnt8,
    txtEnt9,
    txtEnt10,
    txtEnt11,
  ];

  const hallHrefArr = [
    txtHall1,
    txtHall2,
    txtHall3,
    txtHall4,
    txtHall5,
  ];

  const entrances = allEntrancesId.map((id, index) => {
    const {cx, cy} = verticesOnFloor[1].find(ele => (ele.id === id));
    return {
      href: entranceHrefArr[index],
      cx,
      cy,
    };
  });

  const halls = allHallsId.map((id, index) => {
    const { cx, cy } = verticesOnFloor[1].find(ele => (ele.id === id));
    return {
      href: hallHrefArr[index],
      cx,
      cy
    };
  });

  return (
    /* FOR 1 FLOOR */
    <>
    {/* Do not use conditional rendering but use display_none for the oddish which only happens on the real device */}
      <g className={floorLevel !== 1 ? 'display_none' : ''}>
        {
          // entrances.map(item => (
          //   <DynamicIcon
          //     key={item.cx + '_' +item.cy}
          //     x={item.cx}
          //     y={item.cy}
          //     rotate={rotate}
          //     href={item.href}
          //     logoRectSize={item.size || 60}
          //   />
          // ))
        }
        {
          // halls.map(item => (
          //   <DynamicIcon
          //     key={item.cx + '_' +item.cy}
          //     x={item.cx}
          //     y={item.cy}
          //     rotate={rotate}
          //     href={item.href}
          //     logoRectSize={60}
          //   />
          // ))
        }
        <DynamicIcon
          x={246}
          y={190}
          rotate={rotate}
          href={aeonLogo}
          logoRectSize={60}
        />
      </g>
      {/* Do not use conditional rendering but use display_none for the oddish which only happens on the real device */}
      <g className={floorLevel !== 2 ? 'display_none' : ''}>
        <DynamicIcon
            x={225}
            y={160}
            rotate={rotate}
            href={aeonLogo}
            logoRectSize={60}
          />
      </g>
      <g className={floorLevel !== 3 ? 'display_none' : ''}>
        <DynamicIcon
          x={368}
          y={247}
          rotate={rotate}
          href={aeonHall}
          logoRectSize={40}
        />
      </g>
    </>
  /* \\\ FOR 1 FLOOR */
  );
}

export default React.memo(StaticData);